import { useState } from "react";
import { cancelOrder } from "apis/order";

import Modal from "@stadium/ui/src/components/ModalNew";
import {
  CloseButton,
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalFooter,
  ModalHeader,
} from "@stadium/ui/src/components/ModalNew/utils";
import Multimedia from "@components/shared/multimedia";

import { InternalButton } from "@sharedComponents/buttons";

import imageIcon from "@stadium/ui/src/assets/images/svg/red-alert-icon.svg";

import styles from "./main.module.scss";

const CancelOrderModal = ({
  closeModal,
  orderNumber,
  postCancelOrderSuccess,
  isReOrderableOrder,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const onCancelOrder = () => {
    setIsLoading(true);
    cancelOrder(orderNumber)
      .then(() => postCancelOrderSuccess(orderNumber))
      .finally(() => {
        closeModal();
        setIsLoading(false);
      });
  };

  return (
    <Modal closeModal={closeModal} className={styles.cancelModal}>
      <ModalDialog className={styles.modalDialog}>
        <ModalContent>
          <ModalHeader className={styles.modalHeader}>
            <div className={styles.leftBlock}>
              <div className={styles.title}>Are you sure you want to cancel this order? </div>
              <div className={styles.infoText}>
                {isReOrderableOrder
                  ? "If you'd like to reorder, you'll need to place an order through the order link again."
                  : "Your order will be instantly refunded as Stadium Points."}
              </div>
            </div>
            <CloseButton onClick={closeModal} className={styles.iconClose} />
          </ModalHeader>
          <ModalBody className={styles.modalBody}>
            <div className={styles.alertImageBlock}>
              <Multimedia
                type="image"
                src={imageIcon}
                width={96}
                height={86}
                alt="Stadium"
                className={styles.alertImg}
              />
            </div>
          </ModalBody>
          <ModalFooter className={styles.modalFooter}>
            <InternalButton styleType="link" onClick={closeModal} className={styles.btnCancel}>
              cancel
            </InternalButton>
            <InternalButton
              isLoading={isLoading}
              onClick={onCancelOrder}
              styleType="danger"
              className={styles.mainCta}
            >
              Yes, cancel order
            </InternalButton>
          </ModalFooter>
        </ModalContent>
      </ModalDialog>
    </Modal>
  );
};

export default CancelOrderModal;
